import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { backgroundSet } from '../../../../../redux/helpers/setBackground';


class PageBackgroundImage extends Component {
  shouldComponentUpdate(nextProps) {
    const { thumbnail } = this.props;
    if (nextProps.thumbnail !== thumbnail) {
      return true;
    }
    return false;
  }


  setImage = () => {
    const {
      full, thumbnail, pages, lang, sizes,
    } = this.props;
    backgroundSet(thumbnail, full, pages, lang, sizes, this.props);
  }

  render() {
    const { src } = this.props;
    return (
      <div
        onClick={() => this.setImage()}
        onKeyDown={() => {}}
        role="presentation"
      >
        <img
          src={src}
          alt=""
        />
      </div>
    );
  }
}

PageBackgroundImage.defaultProps = {
  src: '',
  thumbnail: '',
  full: '',
  pages: {},
  lang: {},
  sizes: {},
  dispatch: () => {},
  isBabyBook: false,
  handleBackgroundOpen: () => {},
  backgroundSelected: false,
};

PageBackgroundImage.propTypes = {
  src: PropTypes.string,
  thumbnail: PropTypes.string,
  full: PropTypes.string,
  pages: PropTypes.object,
  lang: PropTypes.object,
  sizes: PropTypes.object,
  dispatch: PropTypes.func,
  isBabyBook: PropTypes.bool,
  handleBackgroundOpen: PropTypes.func,
  backgroundSelected: PropTypes.bool,
};


export default connect(state => ({
  pages: state.entities.pages.byId,
  isBabyBook: state.bookProperties.isBabyBook,
  coverType: state.bookProperties.cover.type,
  backgroundSelected: state.editorUI.backgroundImageSelected,
  datePlaceholders: state.entities.datePlaceholders,
}))(PageBackgroundImage);




// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/colors/page-background-image/PageBackgroundImage.jsx